import { clsx } from 'clsx';
import { ComponentProps, FC, ReactElement } from 'react';

import { Button } from './Button';

type Props = Prettify<
  Omit<
    ComponentProps<typeof Button>,
    'children' | 'styling' | ' startIcon' | 'endIcon' | 'title' | 'fullWidth' | 'ref'
  > & {
    styling?: 'square' | 'round';
    variant?: 'accent' | 'primary' | 'secondary' | 'tertiary';
    /** App-bound `<Icon name="…" />` (or equivalent); keep `name` a string literal for the sprite build. */
    icon: ReactElement;
    /** Title of the button, used for accessibility purposes */
    title: string;
  }
>;

export const ButtonIcon: FC<Props> = ({ icon, styling = 'square', className, ...props }) => (
  <Button {...(props as any)} className={clsx(className, 'button--buttonIcon', `button--${styling}`)}>
    {icon}
  </Button>
);
